var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLanguage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "language_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h21.541v17.905H0z",
  "data-name": "Rectangle 7711"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19819"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19794"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M20 0A20 20 0 1 1 0 20 20 20 0 0 1 20 0",
  "data-name": "Path 27437"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19767"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#language_svg__a)",
  "data-name": "Group 19766",
  transform: "translate(9.23 11.047)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M.773 17.133V7.135",
  "data-name": "Line 1697"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M.773 17.133h13.633",
  "data-name": "Line 1698"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.768 7.135v3.636",
  "data-name": "Line 1699"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.406.773H7.135",
  "data-name": "Line 1700"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M.773 7.135A6.36 6.36 0 0 1 7.135.773",
  "data-name": "Path 27413"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.768 7.135A6.36 6.36 0 0 0 14.406.773",
  "data-name": "Path 27414"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M20.768 10.77a6.36 6.36 0 0 1-6.362 6.362",
  "data-name": "Path 27415"
}), /*#__PURE__*/React.createElement("path", {
  d: "m3.964 12.306 2.692-6.59h.536l2.673 6.59h-.766L6.781 6.491h.276L4.71 12.306ZM5.2 9.978h3.449v.613H5.2Z",
  "data-name": "Path 27416"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.184 7.321a6.8 6.8 0 0 1-1.568 2.821 5 5 0 0 0 .41.322 8.3 8.3 0 0 0 2.323 1.143.28.28 0 0 1 .213.271.3.3 0 0 1-.022.11c-.051.161-.147.227-.264.227a.4.4 0 0 1-.161-.029 7.9 7.9 0 0 1-2.484-1.3c-.147-.117-.286-.227-.418-.352a6 6 0 0 1-.418.344 9 9 0 0 1-2.454 1.319.4.4 0 0 1-.132.022.29.29 0 0 1-.286-.205.3.3 0 0 1-.022-.11.31.31 0 0 1 .22-.278 7.9 7.9 0 0 0 2.477-1.312c.066-.059.139-.11.205-.169a7 7 0 0 1-1.546-2.821h-1.15c-.132 0-.2-.125-.2-.278s.066-.256.2-.256h2.777v-.945c0-.139.11-.242.293-.242s.3.1.3.242v.945h2.9c.125 0 .2.11.2.256s-.073.278-.2.278Zm-3.349 0a6.2 6.2 0 0 0 1.378 2.425 5.75 5.75 0 0 0 1.348-2.425Z",
  "data-name": "Path 27417"
})))))));
export { SvgLanguage as ReactComponent };
export default __webpack_public_path__ + "static/media/language.adb3ca03715b1de2c18c3bb8acfda8c9.svg";